import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

type Props = {
  companyId: string
  onSuccess?: () => void
}

export const useUpdateBackofficeCanonicalTopicMutation = ({ companyId, onSuccess }: Props) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      canonicalTopicId,
      label,
      description,
    }: {
      canonicalTopicId: string
      label?: string
      description?: string
    }) => {
      await axios.put(`/backoffice/canonicalTopics/${canonicalTopicId}`, {
        companyId,
        label,
        description,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["canonical-topic"],
      })
      onSuccess?.()
    },
  })
}
